module.exports = __webpack_public_path__ + "static/media/open-field.6179bfa6.png";